// Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Export Components
import { SpinnerComponent } from './spinner.component';

const angularModules = [
  CommonModule, MatProgressSpinnerModule,
];
const exportComponents = [SpinnerComponent];

@NgModule({
  exports: [...exportComponents, MatProgressSpinnerModule],
  imports: [
    ...angularModules,
    ...exportComponents,
  ],
})
export class SpinnerModule { }
